const ProjectTypes = () => {
  const projectTypes = [
    {
      name: 'Poured Wall',
      description: 'Vertical concrete placement for basement walls, retaining structures, and building foundations.',
      icon: 'ri-layout-column-line',
    },
    {
      name: 'Block Fill',
      description: 'Filling concrete blocks for structural reinforcement and enhanced durability.',
      icon: 'ri-layout-masonry-line',
    },
    {
      name: 'Flatwork',
      description: 'Horizontal concrete surfaces including slabs, floors, patios, and walkways.',
      icon: 'ri-layout-grid-line',
    },
    {
      name: 'Footers',
      description: 'Foundation footers and footings for residential and commercial structures.',
      icon: 'ri-arrow-down-double-line',
    },
    {
      name: 'Foundation Pour',
      description: 'Complete foundation systems for new construction and additions.',
      icon: 'ri-building-2-line',
    },
    {
      name: 'Pool',
      description: 'Swimming pool shells, decks, and surrounding concrete work.',
      icon: 'ri-water-flash-line',
    },
    {
      name: 'Columns',
      description: 'Vertical support columns and structural pillars for buildings.',
      icon: 'ri-align-justify',
    },
    {
      name: 'Retaining Wall',
      description: 'Concrete retaining walls for landscaping and erosion control.',
      icon: 'ri-stack-line',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-6">
            Project Types We Handle
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            From residential foundations to commercial high-rises, we have the expertise 
            and equipment to pump concrete for any type of construction project.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {projectTypes.map((type, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:bg-yellow-500 hover:shadow-xl transition-all group cursor-pointer"
            >
              <div className="w-14 h-14 bg-yellow-500 group-hover:bg-black rounded-lg flex items-center justify-center mb-4">
                <i className={`${type.icon} text-3xl text-black group-hover:text-yellow-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-black mb-3">{type.name}</h3>
              <p className="text-gray-700 text-sm leading-relaxed">{type.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="/schedule"
            className="inline-block bg-yellow-500 text-black px-10 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-all cursor-pointer whitespace-nowrap"
          >
            SCHEDULE YOUR PROJECT
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProjectTypes;